import type { ReactNode } from 'react';
import { TRAFFIC_LIGHT_DOT_CLASSES } from '@/lib/tone';

/**
 * Shared "browser chrome" card frame for illustrative product mockups — the same visual
 * language as Hero.tsx's preview panel, extracted so every feature/blog mock shares one look.
 * Never real product screenshots (the platform hasn't shipped) — always labeled illustrative.
 */
export function IllustrationFrame({
  label = 'app.nexusrmm.ai',
  children,
}: {
  label?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] shadow-[0_40px_90px_-35px_rgba(139,61,240,0.35)]">
      <div className="flex items-center gap-2 border-b border-white/10 bg-white/[0.03] px-4 py-3">
        {TRAFFIC_LIGHT_DOT_CLASSES.map((cls) => (
          <span key={cls} className={`h-2.5 w-2.5 rounded-full ${cls}`} />
        ))}
        <span className="ml-2 text-xs text-white/40">{label}</span>
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

export function IllustrationCaption(): JSX.Element {
  return <p className="mt-2 text-right text-xs text-white/40">Illustrative preview — not live data.</p>;
}
